import {toInt, toISODate, toDecimal, formatDateBr} from "../../../../utils/convert-fields"

export const mapEventosOrdinariosPayload = (tableData = []) => {
    const periodicidadeReverseMap = {
        "Diária": 1,
        "Mensal": 2,
        "Trimestral": 3,
        "Semestral": 4,
        "Anual": 5,
        "Não tem": 6
    }
    
    const eventosOrdinarios = tableData
        .filter(column =>
            column &&
            Object.keys(column).length > 0 &&
            Object.values(column).some(v => v !== "" && v !== null && v !== undefined)
        )
        .map(column => ({
                IDFluxoEvento: toInt(column.IDFluxoEvento) ?? null,
                DataReferencia: toISODate(column.DataReferencia),
                Indexador: column.Indexador || null,
                ValorNominal: toDecimal(column.ValorNominal) ?? null,
                LiquidezDiaria: toInt(column.LiquidezDiaria) ?? 0,
                IndexadorCorrecaoPercentual: toDecimal(column.IndexadorCorrecaoPercentual) ?? null,
                Defasagem: toInt(column.Defasagem) ?? 0,
                CalculoDiasIndexador: column.CalculoDiasIndexador || null,
                FormulaIndexador: column.FormulaIndexador || null,
                PeriodicidadeAtualizacaoMonetaria:
                    periodicidadeReverseMap[column.PeriodicidadeAtualizacaoMonetaria] ??
                    toInt(column.PeriodicidadeAtualizacaoMonetaria) ??
                    null,
                MesAniversarioAnualSemestral: column.MesAniversarioAnualSemestral || null,
                ProjecaoInflacao: toInt(column.ProjecaoInflacao) ?? 0,
                InflacaoNegativa: toInt(column.InflacaoNegativa) ?? 0,
                RecalculoProjecao: toInt(column.RecalculoProjecao) ?? 0,
                DataEvento: toISODate(column.DataEvento),
                DataEventoEfetiva: toISODate(column.DataEventoEfetiva),
                DataAniversarioJuros: toISODate(column.DataAniversarioJuros),
                DataLiquidacao: toISODate(column.DataLiquidacao),
                AplicacaoAmortizacao: column.AplicacaoAmortizacao || null,
                AmortizacaoOrdinariaPercentual: toDecimal(column.AmortizacaoOrdinariaPercentual) ?? null,
                TaxaJuros: toDecimal(column.TaxaJuros) ?? null,
                CalculoDias: column.CalculoDias || null,
                JurosCapitalizacao: column.JurosCapitalizacao || null,
                JurosIncorporacaoProgramadaPercentual: toDecimal(column.JurosIncorporacaoProgramadaPercentual) ?? null,
                DataRentabilidadeInicio: toISODate(column.DataRentabilidadeInicio),
                DataRentabilidadeFim: toISODate(column.DataRentabilidadeFim),
                CalculoFatorJuros: column.CalculoFatorJuros || null,
                CasasFatorJuros: toInt(column.CasasFatorJuros) ?? 0,
                CalculoJuros: column.CalculoJuros || null,
                CasasJuros: toInt(column.CasasJuros) ?? 0,
                CalculoFatorCorrecao: column.CalculoFatorCorrecao || null,
                CasasFatorCorrecao: toInt(column.CasasFatorCorrecao) ?? 0,
                CalculoCorrecao: column.CalculoCorrecao || null,
                CasasCorrecao: toInt(column.CasasCorrecao) ?? 0,
                CalculoFatorJurosCDI: column.CalculoFatorJurosCDI || null,
                CasasFatorJurosCDI: toInt(column.CasasFatorJurosCDI) ?? 0,
                CalculoVNA: column.CalculoVNA || null,
                CasasVNA: toInt(column.CasasVNA) ?? 0,
                CalculoFatorDesconto: column.CalculoFatorDesconto || null,
                CasasFatorDesconto: toInt(column.CasasFatorDesconto) ?? 0,
                CalculoFatorExpectativa: column.CalculoFatorExpectativa || null,
                CasasFatorExpectativa: toInt(column.CasasFatorExpectativa) ?? 0,
                CalculoPU: column.CalculoPU || null,
                CasasPU: toInt(column.CasasPU) ?? 0
        }))

    return {
        EventosOrdinarios: eventosOrdinarios,
    }
}

const periodicidadeMap = {
    1: "Diária",
    2: "Mensal",
    3: "Trimestral",
    4: "Semestral",
    5: "Anual",
    6: "Não tem"
}


export const mapEventosOrdinariosToTable = (apiData = [], cetip, versaoDocumento, IDEmissao) => {
    if (!apiData || apiData.length === 0) return [{}]

    return apiData.map(item => ({
        IDFluxoEvento: item.IDFluxoEvento ?? "",
        IDEmissao: IDEmissao ?? item.IDEmissao ?? "",
        VersaoDocumento: versaoDocumento ?? item.VersaoDocumento ?? "",
        DataReferencia: formatDateBr(item.DataReferencia),
        CETIP: cetip ?? item.CETIP ?? "",
        Indexador: item.Indexador || "",
        ValorNominal: item.ValorNominal ?? "",
        LiquidezDiaria: item.LiquidezDiaria ?? 0,
        IndexadorCorrecaoPercentual: item.IndexadorCorrecaoPercentual ?? "",
        Defasagem: item.Defasagem ?? 0,
        CalculoDiasIndexador: item.CalculoDiasIndexador || "",
        FormulaIndexador: item.FormulaIndexador || "",
        PeriodicidadeAtualizacaoMonetaria:
            periodicidadeMap[item.PeriodicidadeAtualizacaoMonetaria] ??
            item.PeriodicidadeAtualizacaoMonetaria ??
            "",
        MesAniversarioAnualSemestral: item.MesAniversarioAnualSemestral || "",
        ProjecaoInflacao: item.ProjecaoInflacao ?? 0,
        InflacaoNegativa: item.InflacaoNegativa ?? 0,
        RecalculoProjecao: item.RecalculoProjecao ?? 0,
        DataEvento: formatDateBr(item.DataEvento),
        DataEventoEfetiva: formatDateBr(item.DataEventoEfetiva),
        DataAniversarioJuros: formatDateBr(item.DataAniversarioJuros),
        DataLiquidacao: formatDateBr(item.DataLiquidacao),
        AplicacaoAmortizacao: item.AplicacaoAmortizacao || "",
        AmortizacaoOrdinariaPercentual: item.AmortizacaoOrdinariaPercentual ?? "",
        TaxaJuros: item.TaxaJuros ?? "",
        CalculoDias: item.CalculoDias || "",
        JurosCapitalizacao: item.JurosCapitalizacao || "",
        JurosIncorporacaoProgramadaPercentual: item.JurosIncorporacaoProgramadaPercentual ?? "",
        DataRentabilidadeInicio: formatDateBr(item.DataRentabilidadeInicio),
        DataRentabilidadeFim: formatDateBr(item.DataRentabilidadeFim),
        CalculoFatorJuros: item.CalculoFatorJuros || "",
        CasasFatorJuros: item.CasasFatorJuros ?? 0,
        CalculoJuros: item.CalculoJuros || "",
        CasasJuros: item.CasasJuros ?? 0,
        CalculoFatorCorrecao: item.CalculoFatorCorrecao || "",
        CasasFatorCorrecao: item.CasasFatorCorrecao ?? 0,
        CalculoCorrecao: item.CalculoCorrecao || "",
        CasasCorrecao: item.CasasCorrecao ?? 0,
        CalculoFatorJurosCDI: item.CalculoFatorJurosCDI || "",
        CasasFatorJurosCDI: item.CasasFatorJurosCDI ?? 0,
        CalculoVNA: item.CalculoVNA || "",
        CasasVNA: item.CasasVNA ?? 0,
        CalculoFatorDesconto: item.CalculoFatorDesconto || "",
        CasasFatorDesconto: item.CasasFatorDesconto ?? 0,
        CalculoFatorExpectativa: item.CalculoFatorExpectativa || "",
        CasasFatorExpectativa: item.CasasFatorExpectativa ?? 0,
        CalculoPU: item.CalculoPU || "",
        CasasPU: item.CasasPU ?? 0
    }))
}
